"use client";

import { useTranslations } from "next-intl";

import { MovedAccounts } from "@/components/expense/fields/MovedAccounts";
import { FormItem, FormLabel } from "@/components/ui/form";

interface IMovedAccountSelectorProps {
    isPending: boolean;
    value: string | undefined;
    onChange: (journal: string | undefined) => void;
}

export const MovedAccountSelector = ({ value, onChange, isPending }: IMovedAccountSelectorProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("numberMovedAccount")} :</FormLabel>
            <div className="w-full md:w-1/2">
                <MovedAccounts value={ value } onChange={ onChange } isPending={ isPending } />
            </div>
        </FormItem>
    );
};
